import isGHMC, { getCurrentDate, getCurrentDateTime, getStartOfCurrentDate } from "../../../../Common/helper/helpar";
import { Formik, Form, Field } from "formik";
import { useEffect } from "react";
import { TonnageCompositionExport } from "./TonnageCompositionExport";
import TonnageCompositionStore from "./store/TonnageCompositionStore";
import { getNowDateTime, getOneMonthPastDateTime } from "../../../AssetVehicle/utils/helpers";

export const TonnageCompositionFilter = ({data}) => {
  const isProd = isGHMC();
  const currentDate = getCurrentDate();
  const currentDateTime = getStartOfCurrentDate();
  const { fetchTonnageCompositionReport } = TonnageCompositionStore();

  const defaultValues = {
    FromDate: currentDate,
    ToDate: currentDate,
  };

  const handleSubmit = (values) => {
    // Save the latest applied filters so the header can display them
    localStorage.setItem(
      "tonnageCompositionFilters",
      JSON.stringify(values)
    );
    fetchTonnageCompositionReport(values);
    // console.log(values);
  };

  useEffect(() => {
    // On initial load, trigger API with defaults and store them for header
    localStorage.setItem(
      "tonnageCompositionFilters",
      JSON.stringify(defaultValues)
    );
    fetchTonnageCompositionReport(defaultValues);
  }, []);

  return (
    <Formik initialValues={defaultValues} enableReinitialize onSubmit={handleSubmit}>
      {({ values, resetForm }) => (
        <Form>
          <div className="d-flex justify-content-between align-items-center mt-3">
            <div className="d-flex align-items-end gap-2 mb-2">
              {/* From Date */}
              <div style={{ width: "200px" }}>
                <div className="form-group-filter">
                  <label className="form-label w-100 text-left">From Date</label>
                  <Field
                    type="date"
                    id="FromDate"
                    name="FromDate"
                    value={values.FromDate}
                    className="form-control bg-white"
                    max={values.ToDate || currentDate} // cannot exceed To Date
                    required
                  />
                </div>
              </div>

              {/* To Date */}
              <div style={{ width: "200px" }}>
                <div className="form-group-filter">
                  <label className="form-label w-100 text-left">To Date</label>
                  <Field
                    type="date"
                    id="ToDate"
                    name="ToDate"
                    value={values.ToDate}
                    className="form-control bg-white"
                    min={values.FromDate}   // cannot be before From Date
                    max={currentDate}       // cannot exceed today
                    required
                  />
                </div>
              </div>

              <button
                type="submit"
                className={`btn w-90 ${isProd ? "search-ghmc" : "search-swm"}`}
              >
                Search
              </button>

              {/* <button
                type="button"
                className={`btn w-90 ${isProd ? "search-ghmc" : "search-swm"}`}
                onClick={() => resetForm({ values: defaultValues })}
              >
                Reset
              </button> */}
            </div>

            <div className="mt-4 d-flex">
              <TonnageCompositionExport data={data} fromDate={values.FromDate} toDate={values.ToDate}/>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};
